let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hSpRM")).then(() => parcelRequire('4pxlo'));